<script lang="ts">
</script>

<div class="bg-danger-1200 border border-solid border-danger text-danger-400 rounded p-2 inline-block  text-sm">
    <slot />
</div>
